module.exports = __webpack_public_path__ + "img/main-bg.a406f356.png";